import Button from "../UI/Button";
import EmptyState from "../UI/EmptyState";

const formatDate = (value) => {
  if (!value) return "-";
  try {
    return new Date(value).toLocaleDateString("id-ID", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch {
    return value;
  }
};

const BlogTable = ({ posts = [], onEdit, onDelete }) => {
  if (!posts.length) {
    return (
      <EmptyState
        title="Belum ada artikel"
        description="Tambahkan artikel atau artikel, studi kasus, dan panduan SEO untuk website Solusi IoT Cerdas."
        icon="📰"
      />
    );
  }

  return (
    <div className="admin-table-wrapper" style={{ overflowX: "auto", background: "#fff", borderRadius: "12px", boxShadow: "0 4px 6px rgba(0,0,0,0.05)" }}>
      <table className="admin-table" style={{ width: "100%", borderCollapse: "collapse", minWidth: "900px" }}>
        <thead style={{ background: "#fffafc", borderBottom: "2px solid #fce7f3" }}>
          <tr>
            <th style={{ padding: "16px", textAlign: "left", color: "#8e1628" }}>Artikel</th>
            <th style={{ padding: "16px", textAlign: "left", color: "#8e1628" }}>Kategori</th>
            <th style={{ padding: "16px", textAlign: "left", color: "#8e1628" }}>Penulis</th>
            <th style={{ padding: "16px", textAlign: "left", color: "#8e1628" }}>Status</th>
            <th style={{ padding: "16px", textAlign: "left", color: "#8e1628" }}>Publikasi</th>
            <th style={{ padding: "16px", textAlign: "center", color: "#8e1628", width: "160px" }}>Aksi</th>
          </tr>
        </thead>
        <tbody>
          {posts.map((item) => (
            <tr key={item.id || item.slug} style={{ borderBottom: "1px solid #f3f4f6", transition: "background 0.2s" }}>
              <td style={{ padding: "16px", minWidth: 280 }}>
                <div className="admin-table__title-block">
                  <strong style={{ display: "block", marginBottom: 4, color: "#1f2937", fontSize: "15px" }}>
                    {item.title}
                  </strong>

                  {item.subtitle && (
                    <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 6, lineHeight: 1.4 }}>
                      {item.subtitle}
                    </div>
                  )}

                  <span style={{ display: "inline-block", fontSize: 11, color: "#ec4899", background: "#fdf2f8", padding: "2px 8px", borderRadius: "4px", marginBottom: item.meta_title ? 4 : 0, wordBreak: "break-word" }}>
                    /blog/{item.slug}
                  </span>

                  {item.meta_title && (
                    <small style={{ display: "block", color: "#9ca3af", lineHeight: 1.4, wordBreak: "break-word", marginTop: "4px" }}>
                      SEO: {item.meta_title}
                    </small>
                  )}
                </div>
              </td>

              <td style={{ padding: "16px", fontWeight: "600", color: "#4b5563" }}>
                {item.category_name || "-"}
              </td>
              
              <td style={{ padding: "16px", color: "#4b5563" }}>
                {item.author_name || item.author_name_display || "Admin"}
              </td>

              <td style={{ padding: "16px" }}>
                <span style={{
                  padding: "4px 10px",
                  borderRadius: "20px",
                  fontSize: "12px",
                  fontWeight: "bold",
                  backgroundColor: item.status === "published" ? "#dcfce7" : "#fef3c7",
                  color: item.status === "published" ? "#166534" : "#d97706"
                }}>
                  {item.status === "published" ? "✅ Published" : "📝 Draft"}
                </span>
              </td>

              <td style={{ padding: "16px", fontSize: "13px", color: "#6b7280" }}>
                {formatDate(item.published_at)}
              </td>

              <td style={{ padding: "16px", textAlign: "center" }}>
                <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                  <Button size="sm" variant="outline" onClick={() => onEdit && onEdit(item)} style={{ padding: "6px 12px", fontSize: "12px" }}>
                    Edit
                  </Button>
                  <button 
                    onClick={() => onDelete && onDelete(item)}
                    style={{ padding: "6px 12px", fontSize: "12px", background: "#fee2e2", color: "#ef4444", border: "none", borderRadius: "6px", fontWeight: "bold", cursor: "pointer" }}
                    title="Hapus Artikel"
                  >
                    Hapus
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BlogTable;